import { TextField, styled } from '@mui/material';

export const CustomDatePickerTextField = styled(TextField)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    width: '100%',
}));
